document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-payment-preference="bizum"]');
  if (!button) return;

  event.preventDefault();
  if (button.disabled) return;

  button.disabled = true;

  try {
    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          payment_preference: 'bizum',
        },
      }),
    });
  } catch (error) {
    console.error('Could not set Bizum payment preference:', error);
  }

  window.location.href = `${window.Shopify.routes.root}checkout`;
});